.root {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  border: 1px solid;
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  line-height: var(--leading-snug);
  letter-spacing: var(--tracking-snug);
}

.icon {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin-top: var(--space-0-5);
  display: block;
}

.body {
  flex: 1 1 auto;
  min-width: 0;
}

.success {
  background: var(--success-bg);
  border-color: var(--success-border);
  color: var(--success-fg);
}
.error {
  background: var(--danger-bg);
  border-color: var(--danger-border);
  color: var(--danger-fg);
}
.warning {
  background: var(--warning-bg);
  border-color: var(--warning-border);
  color: var(--warning-fg);
}
.info {
  background: var(--info-bg);
  border-color: var(--info-border);
  color: var(--info-fg);
}
